import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import UserGroupEditDto from '../dto/UserGroupEditDto';

class UserGroupEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'userGroupEditControl';
	}

	/**
	 * @return {Promise<UserGroupEditDto>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new UserGroupEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<UserGroupEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new UserGroupEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {string} name
	 * @return {Promise<UserGroupEditDto>}
	 */
	getDataByName(name) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getDataByName`, {
					name
				})
				.then(response => resolve(new UserGroupEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {UserGroupEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {UserGroupEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new UserGroupEditService();
